export default __webpack_public_path__ + "static/media/drawing-5.9fbe37cd.png";